import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ikas from "../../providers/ikas";
import {
  EnvelopeSimpleIcon,
  PhoneIcon,
  TextAaIcon,
} from "@phosphor-icons/react";
import * as compSettings from "./settings";

const AccountDetail = ({ id, extendedSettings, data, dataSetter }) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Settings değişkenleri
  const containerGap = settings.containerGap?.value;
  const containerPadding = settings.containerPadding?.value;
  const backgroundColor = settings.backgroundColor?.value;
  const inputPadding = settings.inputPadding?.value;
  const inputBackgroundColor = settings.inputBackgroundColor?.value;
  const inputTextColor = settings.inputTextColor?.value;
  const inputBorderColor = settings.inputBorderColor?.value;
  const inputBorderRadius = settings.inputBorderRadius?.value;
  const iconColor = settings.iconColor?.value;
  const errorTextColor = settings.errorTextColor?.value;
  const buttonBackgroundColor = settings.buttonBackgroundColor?.value;
  const buttonTextColor = settings.buttonTextColor?.value;

  const [errorMessages, setErrorMessages] = useState([]);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState(data?.customer?.email);
  const [name, setName] = useState(data?.customer?.firstName);
  const [surname, setSurname] = useState(data?.customer?.lastName);
  const [phone, setPhone] = useState(data?.customer?.phone);

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleNameChange = (e) => setName(e.target.value);
  const handleSurnameChange = (e) => setSurname(e.target.value);
  const handlePhoneChange = (e) => setPhone(e.target.value);

  const handleUpdate = async () => {
    setErrorMessages([]);
    setLoading(true);
    try {
      const result = await ikas.saveMyCustomer({
        firstName: name,
        lastName: surname,
        phone,
      });
      dataSetter(result);
      setToastType("success");
      setToast("Kullanıcı bilgileri değiştirildi");
      setShowToast(true);
      setLoading(false);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => setToast(""), 400);
      }, 1200);

      if (window.history.length > 2) {
        navigate(-1);
      } else {
        navigate("/");
      }
    } catch (err) {
      setToastType("error");
      setToast("Bir hata oluştu");
      setShowToast(true);
      setLoading(false);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => setToast(""), 400);
      }, 1800);
    }
  };

  // Input komponenti (tekrarı azaltmak için küçük bir helper)
  const renderInput = (value, onChange, type, placeholder, Icon) => (
    <div style={{ position: "relative" }}>
      <input
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        disabled={type === "email"}
        style={{
          width: "100%",
          padding: `${inputPadding || 0}px 48px ${inputPadding || 0}px ${
            inputPadding || 0
          }px`,
          background: inputBackgroundColor,
          color: inputTextColor,
          fontSize: 16, // yazı boyutu küçültüldü
          border: `1px solid ${inputBorderColor}`,
          borderRadius: inputBorderRadius,
          transition: "border-color 0.3s, box-shadow 0.3s",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          opacity: type === "email" ? 0.6 : 1,
        }}
      />
      <Icon
        style={{
          position: "absolute",
          width: 22, // ikon küçültüldü
          height: 22,
          top: "50%",
          right: 12, // ikon sağa alındı
          transform: "translateY(-50%)",
          color: iconColor,
        }}
      />
    </div>
  );

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 400,
        minWidth: 200,
        display: "flex",
        flexDirection: "column",
        gap: containerGap,
        padding: containerPadding,
        backgroundColor: backgroundColor,
      }}
    >
      {renderInput(email, handleEmailChange, "email", "E-posta", EnvelopeSimpleIcon)}
      {renderInput(name, handleNameChange, "text", "İsim", TextAaIcon)}
      {renderInput(surname, handleSurnameChange, "text", "Soyisim", TextAaIcon)}
      {renderInput(phone, handlePhoneChange, "text", "Telefon", PhoneIcon)}

      {/* Error Messages */}
      {errorMessages &&
        errorMessages.map((error, index) => (
          <div
            style={{ display: "inline-flex", marginTop: 4, width: "100%" }}
            key={index}
          >
            <label
              style={{
                cursor: "pointer",
                marginLeft: 8,
                color: errorTextColor,
                fontSize: 14, // biraz küçültüldü
              }}
              htmlFor="check-2"
            >
              {error.message}
            </label>
          </div>
        ))}
      {/* Update Button */}
      <p
        style={{
          width: "100%",
          fontSize: 16, // yazı boyutu küçültüldü
          background: buttonBackgroundColor,
          color: buttonTextColor,
          padding: 12,
          marginTop: 16,
          borderRadius: 10, // border radius küçültüldü
          textAlign: "center",
          cursor: "pointer",
          fontWeight: "600", // bold yapıldı
        }}
        onClick={handleUpdate}
      >
        Güncelle
      </p>
      {/* Toast & Loading */}
      <div style={{ position: "relative" }}>
        {toast && (
          <div
            style={{
              position: "fixed",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 100,
              width: "95vw",
              maxWidth: 480,
              padding: 16,
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              fontSize: 16,
              fontWeight: 600,
              textAlign: "center",
              transition: "all 0.4s",
              top: data?.system?.safeArea?.top ?? 20,
              minWidth: 320,
              background: toastType === "error" ? errorTextColor : "#6f59ef",
              color: "#fff",
              opacity: showToast ? 1 : 0,
              pointerEvents: showToast ? "auto" : "none",
            }}
          >
            {toast}
          </div>
        )}
        {loading && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 50,
              background: "rgba(0,0,0,0.4)",
              transition: "opacity 0.2s",
              pointerEvents: "none",
            }}
          ></div>
        )}
      </div>
    </div>
  );
};
export default AccountDetail;